module.exports = __webpack_public_path__ + "static/media/sbi_card.83322da1.svg";